import { render, staticRenderFns } from "./infoAvatar.vue?vue&type=template&id=b36c3190&scoped=true&"
import script from "./infoAvatar.vue?vue&type=script&lang=js&"
export * from "./infoAvatar.vue?vue&type=script&lang=js&"
import style0 from "./infoAvatar.vue?vue&type=style&index=0&id=b36c3190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c3190",
  null
  
)

export default component.exports